<template>
	<form action="" class="scan-box" v-on:submit.prevent="scan">
		<label for="" class="scan-box__label">Scan Barcode</label>
		<input
			class="scan-box__input"
			placeholder="Click here and scan a barcode please"
			v-model="item_serial"
			name="item_serial"
			type="text"
			v-on:keyup="scan"
		/>
	</form>
</template>

<script>
import Vue from "vue";
import axios from "axios";
export default Vue.extend({
	name: "",
	components: {},
	props: ['type'],
	data() {
		return {
			item_serial: "",
			deliveryResp: {}
		};
	},
	methods: {
		async loadZones(){
			let data = {
				item_serial: this.item_serial,
				handler: "test",
				process: this.type,
				sessionid: this.$store.getters.sessionid
				
			};
			await this.$store.dispatch('scanRequest', data);
		},
		scan: function(e) {
		if (e.keyCode !== 13) {
			return;
		} 
		e.preventDefault();
		console.log(this.type);
		
		//alert('Enter was pressed');
		
			
			this.loadZones();
			
			//alert('Done');
			
			this.item_serial = "";
			this.item_serial.$el.focus();
		
		}
	},
	
  
});
</script>

<style lang="scss" scoped>
.scan-box {
	padding: 20px 0 30px;

	&__label {
		// text-transform: uppercase;
		text-align: center;
		display: block;
		margin-bottom: 10px;
		font-weight: 600;
		font-size: 16px;
	}

	&__input {
		border: 1px solid $border-color;
		border-radius: 5px;
		font-size: 14px;
		display: block;
		margin: 0 auto;
		text-align: center;
		padding: 7px 0;
		width: 300px;
	}
}
</style>